import React from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const OptionsUI = (props: UIProperties<OptionsUIConfig>) => {
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}} className='modal-bg modal-disable-select'>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '530px',
				height: '490px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '530px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font">Options</p>
				</div>
				<GeneralButton parameters= {{
					top: '0',
					left: '454px',
					width: '90px',
					srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
					srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
					srcDisabled: null,
					highlightOnHover: false,
					onClicked: () => {
						props.parameters.onCloseClicked();
					}
				}}/>
				<div style={{
					width: '100%',
					height: '420px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<div style={{
						position: 'absolute',
						top: '11px',
						left: '23px',
						width: '482px',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '15pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font">Click the options below to navigate to the pages containing additional information.</p>
					</div>
					<GeneralButtonWithText parameters= {{
						text: 'Tutorial Guide',
						top: '110px',
						left: '182px',
						width: '170px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							window.open('https://www.sharedfedtraining.org/external_content/simlearndidactic/DAARC/DAARCTutorialGuide.pdf', '_blank');
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Orientation Video',
						top: '210px',
						left: '182px',
						width: '170px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							window.open('https://www.sharedfedtraining.org/external_content/simlearndidactic/DAARC/videoPopUp.html', '_blank');
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Didactic Video',
						top: '310px',
						left: '182px',
						width: '170px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							window.open('https://www.sharedfedtraining.org/external_content/simlearndidactic/DAARC/didactic.html', '_blank');
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

export interface OptionsUIConfig extends BaseConfig{
	onCloseClicked: () => void;
}

export default OptionsUI;